import { Component, OnInit } from '@angular/core';
import { RoleService } from '@perval/shared';
import { ServicePerval } from '../models/service-perval';
import { ServicePervalService } from '../services/service-perval.service';
import { Role } from '@perval/shared';

@Component({
  selector: 'app-historique-services-container',
  templateUrl: './historique-services.container.html',
  styleUrls: ['./historique-services.container.scss'],
})
export class HistoriqueServicesContainer implements OnInit {
  serviceHistory!: ServicePerval.History;
  searchParams: ServicePerval.SearchParams = {};
  limit: number = 20;
  offset: number = 0;
  sort: { key: string; direction: 'asc' | 'desc' } = {
    key: 'happened_at',
    direction: 'desc',
  };
  isLoading = false;

  constructor(
    private readonly servicePervalService: ServicePervalService,
    private readonly roleService: RoleService,
  ) {}

  get isUserCanAccessReport(): boolean {
    return this.roleService.currentUserRoles.includes(
      Role.SERVICES_HISTORY_ACCESS,
    );
  }

  get isUserCanDownloadReport(): boolean {
    return this.roleService.currentUserRoles.includes(Role.REPORTS_DOWNLOAD);
  }

  get isUserCanEditReport(): boolean {
    return this.roleService.currentUserRoles.includes(Role.REPORTS_EDIT);
  }

  ngOnInit(): void {
    this.init();
  }

  private async init() {
    this.isLoading = true;
    await this.loadServiceHistory();
    this.isLoading = false;
  }

  public async onSearch(
    searchParams: ServicePerval.SearchParams,
  ): Promise<void> {
    this.searchParams = searchParams;
    this.offset = 0;
    await this.loadServiceHistory();
  }

  public async onPageChange(offset: number): Promise<void> {
    this.offset = offset;
    await this.loadServiceHistory();
  }

  public async onSortChanged(event: {
    key: string;
    direction: 'asc' | 'desc';
  }): Promise<void> {
    this.sort = event;
    await this.loadServiceHistory();
  }

  private async loadServiceHistory(): Promise<void> {
    this.serviceHistory =
      await this.servicePervalService.getServicesPervalHistory(
        this.searchParams,
        this.limit,
        this.offset,
        this.sort,
      );
  }
}
